import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssFilePage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    @observable
    protected ex1File: File | null = null;

    protected ex1Uploading: boolean = false;

    // simulate a 500ms upload
    private ex1FileChanged(): void {
        this.ex1Uploading = true;
        setTimeout(() => {
            this.ex1Uploading = false;
        }, 500);
    }

    ////****************** Example 2 ********************************************////

    @observable
    protected ex2File: File | null = null;

    protected ex2Progress: number = -1;
    protected ex2MaxFileSize = 40 * 1024 * 1024;
    protected ex2UploadError: string | null = null;
    protected ex2UnsupportedMediaType: boolean = false;

    private ex2FileChanged(): void {
        if(this.ex2File && this.ex2File.size > this.ex2MaxFileSize) {
            this.ex2Progress = -1;
            this.ex2UploadError = 'ui:messages.errors.upload.maximumSizeExceeded';
            return;
        }
        this.ex2UploadFile();
    }

    private ex2UploadFile(): void {
        if(!this.ex2File) { return; }

        try {
            this.state.beginUpload();
            this.ex2UploadError = null;
            this.ex2Progress = 0;

            if(this.ex2UnsupportedMediaType) {
                this.ex2UploadError = 'ui:messages.errors.upload.unsupportedMediaType';
                this.ex2Progress = -1;
                return;
            }

            const simulateUpload = setInterval(() => {
                if(this.ex2Progress >= 1) {
                    clearInterval(simulateUpload);
                }
                this.ex2Progress += 0.05;
            }, 100);
        }
        catch(error) {
            let uploadError: string = 'ui:messages.errors.upload.$';
            this.ex2UploadError = uploadError;
            this.ex2Progress = -1;
            throw error;
        }
        finally {
            this.state.endUpload();
        }
    }

    ////****************** Example 3 ********************************************////

    @observable
    protected ex3File: File | File[] | null = null;

    @observable
    protected ex3Multiple: boolean = false;

    private ex3MultipleChanged(): void {
        this.ex3File = this.ex3Multiple ? [] : null;
    }

}
